/* eslint-disable prettier/prettier */
import $ from 'jquery';
import * as cookieHelper from './cookieHelper';

const KenticoServiceName = 'Kentico CMS';

export const init = () => {
	const $ucScript = $('#usercentrics-cmp'),
		kenticoConsentUrl = $ucScript.data('kentico-consent-url'),
		hideCookieBarCookieName = $ucScript.data('hide-cookie-bar-cookie-name'),
		showCookieBarEssentialLevelDays = parseInt($ucScript.data('show-cookie-bar-essential-level-days')),
		cookieConsentExpiresDays = parseInt($ucScript.data('cookie-consent-expires-days'));

	async function saveConsent(e) {
		if (!window.UC_UI || !window.UC_UI.isInitialized()) {
			return;
		}

		const eventType = e.detail.type;
		if (eventType == 'ACCEPT_ALL' || eventType == 'DENY_ALL' || eventType == 'SAVE') {
			let services = await window.UC_UI.getServicesBaseInfo();

			const kenticoService = services.find((s) => s.name == KenticoServiceName);
			if (kenticoService) {
				$.post(kenticoConsentUrl, {
					visitorCookiesEnabled: kenticoService.consent.status,
				});
			}

			const cookieExpirationDate = cookieHelper.getExpirationDateFromNow(
				eventType == 'DENY_ALL' ? showCookieBarEssentialLevelDays : cookieConsentExpiresDays,
			);
			cookieHelper.setCookie(hideCookieBarCookieName, true.toString(), cookieExpirationDate);
		}
	}

	async function changeConsent(e) {
		e.preventDefault();

		if (!window.UC_UI || !window.UC_UI.isInitialized()) {
			return;
		}

		window.UC_UI.showSecondLayer();
	}

	function onInitialized() {
		const hideCookieBarCookieValue = cookieHelper.getCookie(hideCookieBarCookieName);

		if (!hideCookieBarCookieValue && !window.UC_UI_SUPPRESS_CMP_DISPLAY) {
			window.UC_UI.showFirstLayer();
		}
	}

	window.addEventListener('UC_UI_CMP_EVENT', saveConsent);
	$("a[href='#cookieBar'], .js-cookie-open").on('click', changeConsent);

	if (window.UC_UI && window.UC_UI.isInitialized()) {
		onInitialized();
	} else {
		window.addEventListener('UC_UI_INITIALIZED', function (e) {
			onInitialized();
		});
	}
};
